import { createReducer, Reducer } from "@reduxjs/toolkit";
import { RemoteResource } from "../common/fetchable";
import { EmptyFetchable, Fetchable } from "../common/fetchable/helpers";
import { StakingActions } from "./actions";
import { StakingDTO } from "./models/dto";

export namespace Staking {
  export const stats: RemoteResource<
    StakingDTO.Responses.GetStats.T,
    StakingDTO.Responses.GetStats.T
  > = {
    fetch: StakingActions.getStats,
    updateStore: StakingActions.setStats,
    selector: (store) => store.staking.stats,
  };
}

/**
 * Interface used for Redux Store
 */
export interface Staking {
  stats: Fetchable<StakingDTO.Responses.GetStats.T>;
}

const initialState: Staking = {
  stats: EmptyFetchable,
};
// Reducer
export const stakingReducer: Reducer<
  Staking,
  StakingActions.Actions
> = createReducer(initialState, (builder) => {
  builder
    .addCase(StakingActions.getStats, (state) => {
      state.stats = {
        status: "loading",
      };
    })
    .addCase(StakingActions.setStats, (state, action) => {
      state.stats = action.payload;
    })
    .addCase(StakingActions.resetStats, (state) => {
      state.stats = EmptyFetchable;
    });
});
